import TabToggle from 'components/commons/tab-toogle'
import { Checkbox, InlineError, Input, Switch } from 'avo-ui'
import Select from 'components/commons/select'
import TextEditor from 'components/commons/text-editor'
import UploadImage from 'components/commons/upload-image'
import Datepicker from 'components/commons/datepicker'
import RadioButton from 'components/commons/radio-button'
import { MultipleSelectGift } from '../../../../containers/voucher/voucher-create/general-settings/MultipleSelectGift'
import Timepicker from 'components/commons/timepicker'
import moment from 'moment/moment'

export const GeneralSettings = ({
    sectionRef,
    voucherDetail,
    isPercentage,
    isNominal,
    options,
    date,
    time,
    voucherType,
    onChangeGift,
    onChangeForm,
    onChangeDateTime,
    onSearchGift,
    errorForm,
}) => {
    return (
        <div ref={sectionRef}>
            <TabToggle
                title={'General Settings'}
                content={
                    <div className={'flex space-x-16'}>
                        <div className={'flex-1 flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Voucher Name</div>
                                <Input
                                    className={'flex-1'}
                                    name={'title'}
                                    placeholder={'Masukkan nama voucher'}
                                    value={voucherDetail?.title}
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.title} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Voucher Code</div>
                                <Input
                                    className={'flex-1'}
                                    name={'code'}
                                    placeholder={'Masukkan kode voucher'}
                                    value={voucherDetail?.code}
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.code} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Voucher Description</div>
                                <div className={`flex-1 ${errorForm?.description ? 'space-y-12' : 'pb-10'}`}>
                                    <TextEditor
                                        defaultValue={voucherDetail?.description || '<p></p>'}
                                        onChange={(value) => onChangeForm({ description: value })}
                                        placeholder={'Isi uraian deskripsi'}
                                    />
                                    <InlineError message={errorForm?.description} />
                                </div>
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Term & Condition</div>
                                <div className={`flex-1 ${errorForm?.terms_and_conditions ? 'space-y-12' : 'pb-10'}`}>
                                    <TextEditor
                                        defaultValue={voucherDetail?.terms_and_conditions || '<p></p>'}
                                        onChange={(value) => onChangeForm({ terms_and_conditions: value })}
                                        placeholder={'Isi uraian term & condition'}
                                    />
                                    <InlineError message={errorForm?.terms_and_conditions} />
                                </div>
                            </div>
                            <div
                                className={`flex flex-col ${(voucherDetail?.thumbnail?.base64 || voucherDetail?.thumbnail) && 'space-y-3'}`}
                            >
                                <div className={'font-semibold text-blue-90'}>Voucher Thumbnail</div>
                                <UploadImage
                                    className={'w-fit'}
                                    classNameImage={'!w-48 !h-48 border border-neutral-30 rounded-md'}
                                    id={'thumbnail'}
                                    value={voucherDetail?.thumbnail?.base64 || voucherDetail?.thumbnail}
                                    onChange={(item) => onChangeForm({ thumbnail: item })}
                                />
                                <InlineError className='mt-2' message={errorForm?.thumbnail} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Show on Checkout Page</div>
                                <div className={'flex items-center space-x-2'}>
                                    <Switch
                                        name={'is_shown_in_checkout'}
                                        checked={!!voucherDetail?.is_shown_in_checkout}
                                        onChange={(item) => onChangeForm({ [item?.name]: item?.checked })}
                                    />
                                    <p className={'font-semibold'}>
                                        {!voucherDetail?.is_shown_in_checkout ? 'Hide' : 'Show'}
                                    </p>
                                </div>
                                <InlineError className='mt-2' message={errorForm?.is_shown_in_checkout} />
                            </div>
                        </div>
                        <div className={'flex-1 flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Voucher Type</div>
                                <Select
                                    name={'type'}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-28'}
                                    placeholder={'Pilih tipe voucher'}
                                    options={options?.voucher_type}
                                    value={voucherDetail?.type}
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.type} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Start Date Voucher</div>
                                <div className={'flex space-x-2'}>
                                    <Datepicker
                                        name={'date_start'}
                                        className={'flex-1'}
                                        value={date?.start}
                                        maxDate={date?.end}
                                        minDate={moment()}
                                        onChange={(value) => onChangeDateTime({ name: 'start_date', value })}
                                        format={'YYYY-MM-DD'}
                                    />
                                    <Timepicker
                                        className={'flex-1'}
                                        name={'start_time'}
                                        placeholder='Pilih Waktu'
                                        value={time?.start}
                                        disabled={!date?.start}
                                        onChange={(value) => onChangeDateTime(value)}
                                    />
                                </div>
                                <InlineError className='mt-2' message={errorForm?.date_start} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Expired Date Voucher</div>
                                <div className={'flex space-x-2'}>
                                    <Datepicker
                                        name={'date_expires'}
                                        className={'flex-1'}
                                        value={date?.end}
                                        minDate={date?.start || moment()}
                                        onChange={(value) => onChangeDateTime({ name: 'end_date', value })}
                                        format={'YYYY-MM-DD'}
                                        isClearable
                                    />
                                    <div className={'flex-1 flex-col space-y-3'}>
                                        <Timepicker
                                            className={'w-full'}
                                            name={'end_time'}
                                            placeholder='Pilih Waktu'
                                            value={time?.end}
                                            disabled={!date?.end}
                                            onChange={(value) => onChangeDateTime(value)}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.date_expires} />
                                    </div>
                                </div>
                            </div>
                            {voucherDetail?.type && voucherDetail?.type?.value !== voucherType[3]?.value && (
                                <>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Discount Type</div>
                                        <div className={'flex space-x-2'}>
                                            <RadioButton
                                                label={'Percentage'}
                                                name={'discount_type'}
                                                value={'percentage'}
                                                checked={isPercentage}
                                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                            />
                                            <RadioButton
                                                label={'Nominal'}
                                                name={'discount_type'}
                                                value={'nominal'}
                                                checked={isNominal}
                                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                            />
                                        </div>
                                        <InlineError className={'mt-2'} message={errorForm?.discount_type} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Voucher Amount</div>
                                        <Input
                                            type={isPercentage ? 'number' : 'currency'}
                                            className={'flex-1'}
                                            name={isPercentage ? 'amount_percentage' : 'amount_nominal'}
                                            addonBefore={isNominal && 'Rp'}
                                            addonAfter={isPercentage && '%'}
                                            placeholder={'Masukkan nilai'}
                                            value={
                                                isPercentage
                                                    ? voucherDetail?.amount_percentage
                                                    : voucherDetail?.amount_nominal
                                            }
                                            onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                        />
                                        <InlineError
                                            className={'mt-2'}
                                            message={
                                                isPercentage ? errorForm?.amount_percentage : errorForm?.amount_nominal
                                            }
                                        />
                                    </div>
                                    {isPercentage && (
                                        <div className={'flex flex-col space-y-3'}>
                                            <div className={'font-semibold text-blue-90'}>Voucher Max Amount</div>
                                            <Input
                                                type={'currency'}
                                                className={'flex-1'}
                                                name={'max_amount'}
                                                addonBefore={'Rp'}
                                                placeholder={'Masukkan nilai maksimal'}
                                                value={voucherDetail?.max_amount}
                                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                            />
                                            <InlineError className={'mt-2'} message={errorForm?.max_amount} />
                                        </div>
                                    )}
                                </>
                            )}
                            {voucherDetail?.type?.value === voucherType[3]?.value && (
                                <>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Select Gift</div>
                                        <MultipleSelectGift
                                            name={'gifts'}
                                            onSearch={onSearchGift}
                                            value={voucherDetail?.gifts}
                                            options={options?.gifts}
                                            errors={errorForm?.selected_gift}
                                            onChange={onChangeGift}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.gifts} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <Checkbox
                                            name={'is_free_shipping'}
                                            checked={voucherDetail?.is_free_shipping}
                                            disabled={!voucherDetail?.gifts?.length}
                                            label={'Free Shipping '}
                                            onChange={(item) => onChangeForm({ [item?.name]: item?.checked })}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.is_free_shipping} />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                }
            />
        </div>
    )
}
